// Tenants page helpers (ADR 0010): slugs and the site list for "move site".
import type { TenantInfo } from '../api/types.js';

/** Same rule as central-api: lower-case letters, digits and dashes, starting with a letter. */
export const TENANT_SLUG = /^[a-z][a-z0-9-]{1,62}$/;

/** A slug proposal from a tenant name (`Hotel Elements, s.r.o.` → `hotel-elements-s-r-o`). */
export function slugify(name: string): string {
  const s = name
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^[^a-z]+/, '')
    .replace(/-+$/, '')
    .slice(0, 63)
    .replace(/-+$/, '');
  return s;
}

/** Every site with its current tenant, sorted by site name. */
export function sitesWithTenant(
  tenants: readonly TenantInfo[],
): { id: string; name: string; tenantId: string; tenantName: string }[] {
  return tenants
    .flatMap((t) =>
      t.sites.map((s) => ({ id: s.id, name: s.name, tenantId: t.id, tenantName: t.name })),
    )
    .sort((a, b) => a.name.localeCompare(b.name));
}
